import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Box, Paper, Typography, IconButton, Tooltip } from '@mui/material';

/** Material UI Icons. */
import DeleteIcon from '@mui/icons-material/Delete';

/** Internal Components. */
import { formatOperationDateTime, operationNow, toOperationTime } from 'shared/lib/dateFormatter';

export default function ReminderCards({ title, description, due_date, status, handleReminderDelete }) {
    // 알림이 울릴 시각을 근무지(LA) 기준으로 보여준다.
    const formatted = formatOperationDateTime(due_date);
    // 오늘 울릴 알림인지도 근무지 달력으로 따져야 한국에서 봐도 같은 색이 뜬다.
    const isToday = toOperationTime(due_date)?.isSame(operationNow(), 'day') ?? false;
    // Background color based on the due date.
    const backgroundColor = isToday ? '#d92936' : '#f48704';

    return (
        <Paper
            sx={{
                display: 'flex',
                width: '100%',
                minHeight: '66px',
                bgcolor: 'white',
            }}
        >
            <Box
                sx={{
                    width: '2%',
                    bgcolor: backgroundColor,
                }}
            />
            <Box sx={{ width: '90%', p: 0.5, px: 1.5 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Typography
                        sx={{
                            fontSize: 13,
                            fontWeight: 500,
                            width: '190px',
                        }}
                    >
                        {title}
                    </Typography>
                </Box>

                <Typography
                    sx={{
                        fontSize: 11,
                        fontWeight: 400,
                        whiteSpace: 'pre-line',
                    }}
                >
                    {description}
                </Typography>
                <Typography
                    sx={{
                        fontSize: 11,
                        fontWeight: 400,
                    }}
                >
                    {formatted}
                </Typography>
            </Box>
            <Box
                sx={{
                    width: '8%',
                    py: 1,
                    pr: 0.5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Tooltip title="Delete" arrow>
                    <IconButton
                        onClick={handleReminderDelete}
                        size="small"
                        sx={{
                            p: '1px',
                            color: '#003a52',
                            ':hover': { bgcolor: '#003a52', color: 'white' },
                        }}
                    >
                        <DeleteIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                </Tooltip>
            </Box>
        </Paper>
    );
}
